var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CommunicationsManagerOf } from '../communications/manager';
import { CrossWindowCommunicationDataContract } from './crossWindowDataContract';
/**
 * @inheritdoc
 */
var CrossWindowCommunicationsManager = /** @class */ (function (_super) {
    __extends(CrossWindowCommunicationsManager, _super);
    /**
     * Constructor
     *
     * @param inboundEndpoint The endpoint for receiving messages.
     * @param inboundEventType The types of messages to receive.
     * @param outboundEndpoint The endpoint to sent messages.
     * @param outboundEventType The messages to send.
     * @param origin The origin to communicate with.
     */
    function CrossWindowCommunicationsManager(inboundEndpoint, inboundEventType, outboundEndpoint, outboundEventType, origin) {
        var _this = _super.call(this, inboundEndpoint, inboundEventType, outboundEndpoint, outboundEventType) || this;
        _this.origin = origin;
        return _this;
    }
    /**
     * @inheritdoc
     */
    CrossWindowCommunicationsManager.prototype.readEvent = function (e) {
        var messageEvent = e;
        if (!messageEvent || messageEvent.origin !== this.origin)
            return null;
        var data = messageEvent.data;
        if (!data || data.type !== this.inboundEventType)
            return null;
        return data.detail ? data.detail : null;
    };
    /**
     * @inheritdoc
     */
    CrossWindowCommunicationsManager.prototype.startReceiving = function (inboundEndpoint, handler) {
        inboundEndpoint.addEventListener('message', handler);
    };
    /**
     * @inheritdoc
     */
    CrossWindowCommunicationsManager.prototype.stopReceiving = function (inboundEndpoint, handler) {
        inboundEndpoint.removeEventListener('message', handler);
    };
    /**
     * @inheritdoc
     */
    CrossWindowCommunicationsManager.prototype.sendEvent = function (outboundEndpoint, event) {
        var data = new CrossWindowCommunicationDataContract(this.outboundEventType, event);
        outboundEndpoint.postMessage(data, this.origin);
    };
    return CrossWindowCommunicationsManager;
}(CommunicationsManagerOf));
export { CrossWindowCommunicationsManager };
//# sourceMappingURL=crossWindowManager.js.map